import { BaseError, ErrorCodes, ErrorTypes } from '@klarna-web-sdk/utils'

export class ConfigError extends BaseError {
  constructor(type: ErrorTypes, code: ErrorCodes, message: string) {
    super('ConfigError', type, code, message)

    this.logToTracker()
    this.logToConsole()
  }
}
